import { render, staticRenderFns } from "./DialogViewTable.vue?vue&type=template&id=ca89f89a"
import script from "./DialogViewTable.vue?vue&type=script&lang=js"
export * from "./DialogViewTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports